// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/admin-lte/dist/css/skins/skin-green.css
// module id = 692
// module chunks = 1